import { createSelector } from "reselect";

import { schema } from "../schema";
import { TChooserRepo } from "../schema/drawer.def";

export const selectChooserRepoItems = createSelector(
  schema.categoryChooser.select,
  (chooserRepo) =>
    chooserRepo.items
      .filter((item: TChooserRepo) => item.parentId === null)
      .map((item: TChooserRepo) => ({
        ...item,
        children: chooserRepo.items.filter(
          (child: TChooserRepo) => child.parentId === item.id
        ),
      }))
);

export const currentTab = createSelector(
  schema.categoryChooser.select,
  (chooserRepo) => chooserRepo.currentPage
);
